import DynamicMultiSelectInput from 'components/forms/inputs/rhf-inputs/DynamicMultiSelectInput.tsx';
import InfoTooltip from 'components/InfoTooltip';
import { useLazyGetActivePracticeAreasWithFiltersQuery } from 'store/api/practice-areas';
import { PracticeAreaType } from 'types/practice-areas';
import { formatPracticeAreaLabel } from 'utils/practiceAreaUtil';
import { TimecardFormState } from './useTimecardForm';

export const PracticeAreaFields = ({ form }: { form: TimecardFormState }): JSX.Element => {
    const { control, setValue } = form.methods;
    const { isPracticeAreaMandatory } = form;

    return (
        <DynamicMultiSelectInput
            control={control}
            name="practiceAreas"
            label="practice-areas.practice-areas"
            placeholder="timecards.form.select-practice-areas"
            setValue={setValue}
            getOptionLabel={(option) => formatPracticeAreaLabel(option)}
            getOptionIdentifier="id"
            rightLabelComponent={<InfoTooltip text={'timecards.tooltips.practice-areas'} />}
            paginated={{
                fetch: useLazyGetActivePracticeAreasWithFiltersQuery,
                filters: `practiceAreaTypeCode==${PracticeAreaType.PRACTICE_AREA};showInTimecards==true`,
                searchField: 'name',
            }}
            required={isPracticeAreaMandatory}
        />
    );
};
